import { FormControl, FormLabel, FormLabelProps } from "@mui/material";
import { TextField as MuiRffTextField, TextFieldProps } from "mui-rff";

export function TextField(props: TextFieldProps & { formLabelProps?: FormLabelProps; onChange?: (e: any) => void }) {
  const { label, formLabelProps = {}, sx = {}, ...rest } = props;
  const { required } = rest;

  return (
    <FormControl required={required} sx={{ width: "100%" }}>
      <FormLabel
        {...formLabelProps}
        sx={{
          color: "var(--grey-scale-800)",
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "16px",
          mb: 0,
          ...formLabelProps.sx,
        }}
      >
        {label}
      </FormLabel>
      <MuiRffTextField
        sx={{
          mb: "20px",
          width: "325px",
          ...sx,
        }}
        {...rest}
      />
    </FormControl>
  );
}

export default TextField;
